import { render, staticRenderFns } from "./classJgCourse.vue?vue&type=template&id=2d07c9a8&scoped=true"
import script from "./classJgCourse.vue?vue&type=script&lang=js"
export * from "./classJgCourse.vue?vue&type=script&lang=js"
import style0 from "./classJgCourse.vue?vue&type=style&index=0&id=2d07c9a8&prod&lang=less"
import style1 from "./classJgCourse.vue?vue&type=style&index=1&id=2d07c9a8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d07c9a8",
  null
  
)

export default component.exports